import { Row, Col, Spin } from "antd";
import CustomInput from "../../../components/CustomInput/Input";
import CustomSelect from "../../../components/CustomSelect/CustomSelect";
import {
    panRules,
    tenureRules,
    companyNameRules,
    capitalizeWords,
} from "../../../helpers/helpers";
import { useSelector, useDispatch } from "react-redux";
import { ERROR_MSGS } from "../../../constants/constants";
import CustomInputNumber from "../../../components/CustomInputNumber/InputNumber";
import InputWithButton from "../../../components/CustomInput/InputWithButton";
import { kycHistory, verifyPan, busVerifyBusPan, busKycHistory } from "../../../redux/slices/EnqMngtSlice";

const KycBusinessDetails = ({
    kycData,
    busPan,
    busName,
    orgId,
    isReview,
    organizationId,
    token,
}) => {
    const dispatch = useDispatch();
    const { dropdownData, loading, panLoading, kycHistoryData } = useSelector(
        (state) => state.enqMngt
    );
    const { isVerified } =
        kycHistoryData?.kycDetails?.kycPanValue || kycData || {};

    const handleVerifyBtnClick = async (type) => {
        let response;

        if (token) {
            response = await dispatch(
                busVerifyBusPan({
                    busName,
                    pan: busPan,
                    orgId: organizationId,
                    token,
                })
            );
        } else {
            response = await dispatch(
                verifyPan({
                    busName,
                    pan: busPan,
                    orgId,
                })
            );

        }

        if (response?.payload?.statusCode === 201) {
            if (token) {
                dispatch(busKycHistory({ orgId: organizationId, token }))
            } else {
                dispatch(kycHistory(orgId));
            }
        }
    };

    return (
        <Spin spinning={loading}>
            <Row gutter={[24, 0]}>
                <Col xs={24} md={12}>
                    <CustomInput
                        label="Business Name (as per PAN)"
                        name="busName"
                        type="text"
                        isRequired={true}
                        disabled={isReview || isVerified}
                        placeholder="Enter your Business Name"
                        rules={companyNameRules("Business")}
                    />
                </Col>
                <Col xs={0} md={12}></Col>
                <Col xs={24} md={12}>
                    <InputWithButton
                        label="Business PAN"
                        name="busPan"
                        type="text"
                        isRequired={true}
                        isUpperCase={true}
                        placeholder="Enter your Business PAN"
                        rules={panRules}
                        verifyBtn={true}
                        disabled={isReview || isVerified}
                        isVerified={isVerified}
                        verifyLoading={panLoading}
                        disableVerify={
                            isReview || !/[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(busPan || "")
                        }
                        handleVerify={() => handleVerifyBtnClick("pan")}
                    />
                </Col>
                <Col xs={24} md={12}>
                    <CustomSelect
                        label="Business Type"
                        name="busType"
                        disabled
                        isRequired={true}
                        placeholder="Select Business Type"
                        options={dropdownData?.businessTypeList?.map((businessType) => ({
                            value: businessType.businessTypeId,
                            label: capitalizeWords(businessType.businessTypeName),
                        }))}
                        rules={[{ required: true, message: ERROR_MSGS.SEL_COMP_TYPE }]}
                    />
                </Col>

                <Col xs={24} md={12}>
                    <CustomSelect
                        label="Industry Type"
                        name="industryType"
                        showSearch
                        disabled={isReview}
                        isRequired={true}
                        placeholder="Select Industry Type"
                        options={dropdownData?.industryTypeList?.map((industry) => ({
                            value: industry.industryTypeId,
                            label: capitalizeWords(industry.industryTypeName),
                        }))}
                        rules={[{ required: true, message: ERROR_MSGS.SEL_IND_TYPE }]}
                    />
                </Col>
                <Col xs={24} md={12}>
                    <CustomSelect
                        label="Annual Turnover"
                        name="annualTurnover"
                        isRequired={true}
                        disabled={isReview}
                        placeholder="Select Annual Turnover"
                        options={dropdownData?.annualTurnoverList?.map(
                            (annualTurnover) => ({
                                value: annualTurnover.annualTurnoverId,
                                label: capitalizeWords(annualTurnover.annualTurnoverName),
                            })
                        )}
                        rules={[{ required: true, message: ERROR_MSGS.SEL_ANN_TURN }]}
                    />
                </Col>
                <Col xs={24} md={12}>
                    <CustomInput
                        label="Credit Tenure"
                        name="tenure"
                        type="text"
                        disabled={isReview}
                        isRequired={true}
                        placeholder="Enter your Credit Tenure (Between 30 and 90 Days)"
                        rules={tenureRules}
                    />
                </Col>
                <Col xs={24} md={12}>
                    <CustomInputNumber
                        label="Expected Amount"
                        name="expAmt"
                        controls={false}
                        disabled={isReview}
                        isRequired={true}
                        placeholder="How much working capital do you need?"
                        rules={[{ required: true, message: ERROR_MSGS.EXP_AMT_ERR_MSG }]}
                    />
                </Col>
            </Row>
        </Spin>
    );
};

export default KycBusinessDetails;
